import { CircularProgress, InputLabel, MenuItem, Select, SelectProps } from '@mui/material'
import useQueryGet from 'hooks/useQueryGet'
import { ReactNode } from 'react'

const rejectedContentSlugs = [1, 2, 3, 4, 5].map(num => `rejectedCause${num}`)

const separator = '|'

type SlugResponse = {
  id: number
  createdAt: string
  marketLanguageId: number
  availableTranslationId: number
  translation: string
  availableTranslation: {
    id: number
    slug: string
    description: string
    info: string
    type: string
    groupId: number
  }
}

type RejectReasonsSelectProps = SelectProps & {
  label: ReactNode
  langId: number
}

export const RejectReasonsSelect = ({ label, langId, ...rest }: RejectReasonsSelectProps) => {
  const { data: translationsData, isLoading: isTranslationsLoading } = useQueryGet<Array<SlugResponse>>({
    queryKey: [`translations-${rejectedContentSlugs.join(',')}-${langId}`],
    endpoint: `translations/slugs?slugs=${rejectedContentSlugs.join(',')}&marketLanguageId=${langId}`,
  })

  const options =
    Array.isArray(translationsData) && translationsData.length > 0
      ? translationsData.reduce<Array<{ label: string; value: string }>>((arr, el) => {
          const languageReasons = el.translation.split(separator) || []

          if (languageReasons[0]?.trim() && languageReasons[1]?.trim()) {
            // Zapisujemy całość "English | Native"; label (angielski) pokazujemy w dropdownie
            return [
              ...arr,
              {
                label: languageReasons[0].trim(),
                value: `${languageReasons[0].trim()} | ${languageReasons[1].trim()}`,
              },
            ]
          }
          return [...arr]
        }, [])
      : []

  if (isTranslationsLoading) {
    return <CircularProgress size={16} />
  }

  return (
    <>
      <InputLabel sx={{ top: '-8px' }} id="reject-reason-label">
        {label}
      </InputLabel>
      <Select
        labelId="reject-reason-label"
        id="reject-reason-label"
        label={label}
        defaultValue=""
        {...rest}
        MenuProps={{ sx: { maxHeight: 285 } }}
      >
        {options.map(item => (
          <MenuItem key={`reson-${item}`} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </>
  )
}
